import React, { useEffect, useState, useRef } from 'react';
import { Routes, useNavigate, useLocation } from "react-router-dom";

import routes from '../../libs/routes';
import images from "../../libs/images";
import * as API from "../../libs/service";


import { useDispatch, useSelector } from 'react-redux';

import { loadingStart, loadingEnd } from "../../redux/loadingSlice";
import { open, close } from "../../redux/popupSlice";

import Popup01 from "../../pages/popup/Popup01"
import PopupPlanModel from "../../pages/popup/PopupPlanModel"
import PopupProfileEdit from "../../pages/popup/PopupProfileEdit"
import PopupRegisterCoupon from "../../pages/popup/PopupRegisterCoupon"

import ModelOptionCard from "../../components/ModelOptionCard"
import PaginationCoupon from "../../components/PaginationCoupon"


import { ToastContainer, toast, Slide, Flip, Bounce } from 'react-toastify';
import { BrowserView, MobileView, isBrowser, isMobile, isChrome, isSafari, isIOS, isAndroid } from 'react-device-detect';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Autoplay } from 'swiper/modules';
import moment from "moment";


import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/autoplay';
import 'react-toastify/dist/ReactToastify.css';

import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

export default function ProfileCoupon() {
    const location = useLocation();
    
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const lang = useSelector(state => state.langReducer.lang);

    const { mbData } = useSelector((s) => s.usersReducer);

    const fileRef = useRef();

    const [coupon, setCoupon] = useState([]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if(!mbData?.idx) {
            navigate(routes.main);
        } else {
            CouponListFunc()
        }
    }, []);

    const CouponListFunc = async () => {
        dispatch(loadingStart());
        const result = await API.xsollaApis("user/couponlists", { idx: mbData?.idx });
        if(result?.status === 200){
            let lists = [];
            result?.result?.couponsendlist?.map((x, i) => {
                let coupongrouplists = result?.result?.coupongrouplist?.find(item => item?.idx*1 === x?.couponIdx*1);
                x.issueType = coupongrouplists?.couponCode;
                x.discount = coupongrouplists?.discount;
                x.issueDate = moment(coupongrouplists?.create_dt).format('YYYY-MM-DD HH:mm:ss');
                x.statusTxt = x?.status === 0 ? lang === 0 ? '미사용' : 'Not used' : x?.validityDate < moment().format('YYYY-MM-DD HH:mm:ss') ? lang === 0 ? '만료' : 'Expiration' : lang === 0 ? '사용' : 'Used';
                lists.push(x);
                //return x;
            });
            //console.log(lists);
            setCoupon(lists);
        }
        dispatch(loadingEnd());
    }

    const RegisterCoupon = () => {
        dispatch(open({
            component: 
                <PopupRegisterCoupon
                    x_btn={false}
                    button={lang === 0 ? '등록' : 'Register'}
                    buttonCancel={lang === 0 ? '취소' : 'Cancel'}
                    setFunc={() => {
                        dispatch(loadingStart());
                        setTimeout(() => {
                            dispatch(open({
                                component: 
                                    <Popup01
                                        x_btn={false}
                                        text1={lang === 0 ? '쿠폰이 등록되었습니다.' : 'Coupon registered.'}
                                        longButton={lang === 0 ? '확인' : 'OK'}
                                    />
                            }));
                            dispatch(loadingEnd());
                        }, 1000);
                    }}
                />
        }));
    }
    
    return (
        <>
            <div className="main_back">
                <div className="main_part profile padding">
                    <div className="profile_edit_box">
                        <div 
                            className="title_box"
                            onClick={() => {
                                navigate(-1);
                            }}
                        >
                            <img src={require("../../assets/icon/back_arr.svg").default}/>
                            <p>{lang === 0 ? '나의 쿠폰' : 'My Coupon'}</p>
                        </div>

                        <div className="profile_edit coupon">
                            <div className="coupon_title_box">
                                <p>{lang === 0 ? '나의 쿠폰' : 'My Coupon'}</p>
                            </div>

                            {/* <div className="coupon_notice">
                                <p>
                                    {lang === 0
                                        ? '구독 상품을 미리 결제하여 요금을 절감하세요.'
                                        : 'Pre-pay to save on subscription fees.'}
                                </p>

                                <button
                                    type="button"
                                    onClick={() => {
                                        dispatch(open({
                                            component: 
                                                <PopupPlanModel 
                                                    max_width={'480px'}
                                                    longButton={lang === 0 ? '결제하기' : 'Make Payment'}
                                                    couponSale={true}
                                                    pay_card={true}
                                                    plan_plus={true}
                                                />
                                        }));
                                    }}
                                >
                                    {lang === 0 ? '결제하기' : 'Make Payment'}
                                    <img src={require("../../assets/icon/right_arr_on.svg").default}/>
                                </button>
                            </div> */}

                            <div className="coupon_title_box sub" style={{ marginTop: 20 }}>
                                <p>{lang === 0
                                    ? '쿠폰은 연 구독 상품에만 적용 가능합니다.'
                                    : 'Coupons apply only to annual payment products.'}
                                </p>
                                {/* <button
                                    type="button"
                                    onClick={() => {
                                        RegisterCoupon()
                                    }}
                                >
                                    {lang === 0 ? '쿠폰 등록' : 'Register Coupon'}
                                </button> */}
                            </div>

                            <PaginationCoupon coupon={coupon}/>
                        </div>
                    </div>
                </div>
            </div> {/* 메인 div */}

            <ToastContainer
                position="bottom-center"
                transition={Slide}
                limit={1}
                closeButton={false}
                autoClose={1000}
                style={{ width: isBrowser ? 400 : '100%', marginBottom: isBrowser ? 60 : 70 }}
                hideProgressBar
            />
        </>
    );
}
